export const formatarCnpj = (valor = "") => {
  const numeros = String(valor).replace(/\D/g, "").slice(0, 14);

  if (!numeros) {
    return "";
  }

  return numeros
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};
